// extracted by mini-css-extract-plugin
export default {"loginContainer":"Login_loginContainer__LoiqS","forgotPasswordLink":"Login_forgotPasswordLink__jgQ27","registerLink":"Login_registerLink__0Sorx"};